import { QueryParamBuilder, type FilterMenuInput } from '../../../componentsV2'
import { useIntegrations } from '../../../hooks/integrations/useIntegrations'
import { Icon } from '../../../elementsv2'
import { FILTER_SEPARATOR } from '../../../componentsV2/QueryParamBuilder/parseParams'
import { useSuspenseQuery } from '@tanstack/react-query'
import { botQueryOptions } from '../../../queries'

type Props = { workspaceId: string; botId: string }

export const ConversationsQueryParamBuilder = ({ workspaceId, botId }: Props) => {
  const bot = useSuspenseQuery(botQueryOptions({ botId, workspaceId })).data
  const botIntegrations = useIntegrations({
    workspaceId,
    integrationIds: Object.values(bot.integrations).map((i) => i.id),
  })

  const integrationTags = useIntegrations({
    workspaceId,
    integrationIds: Object.values(bot.integrations).map((i) => i.id),
  })
    .filter((i) => Object.values(i.channels).flatMap((channel) => Object.keys(channel.conversation.tags)).length > 0)
    .map<FilterMenuInput>((i) => ({
      name: i.name,
      icon: <Icon size="2" variant={'surface'} color={'gray'} icon={(props) => <img src={i.iconUrl} {...props} />} />,
      value: Object.values(i.channels).flatMap((channel) =>
        Object.keys(channel.conversation.tags).map<FilterMenuInput>((t) => ({
          name: t,
          paramName: `tags`,
          type: 'object',
          value: `${i.name}:${t}${FILTER_SEPARATOR}`,
        }))
      ),
    }))

  const filters: FilterMenuInput[] = [
    { name: 'Conversation', paramName: 'conversationId', type: 'string' },
    { name: 'Message', paramName: 'messageId', type: 'string' },
    { name: 'Participant', paramName: 'participantIds', type: 'array' },
    {
      name: 'Integration',
      value: botIntegrations.map((integration) => ({
        name: integration.name,
        paramName: 'integrationName',
        value: integration.name,
        icon: (
          <Icon
            size="2"
            variant={'surface'}
            color={'gray'}
            icon={(props) => <img src={integration.iconUrl} {...props} />}
          />
        ),
      })),
    },
    ...Object.keys(bot.conversation.tags)
      .filter((t) => !['upstream', 'downstream'].includes(t))
      .map<FilterMenuInput>((t) => ({
        name: t,
        paramName: 'tags',
        type: 'object',
        value: `${t}${FILTER_SEPARATOR}`,
      })),
    { name: 'Integration Tags', value: integrationTags },
  ]

  return <QueryParamBuilder filters={filters} />
}
